import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { InboxService } from '../../../inbox.service';
import { SocketService } from '../../../../../services/socket.service';
import { SessionService } from '../../../../../services/session.service';
import { Observable } from 'rxjs/Rx';
import { RxComponent } from '../../../../common/rx.component';

@Component({
    selector: 'itpx-inbox-tab',
    templateUrl: './inbox-tab.component.html',
    styleUrls: ['./inbox-tab.component.css']
})
export class InboxTabComponent extends RxComponent implements OnInit {

    @Input() url: string;
    @Input() tabConfig: Array<any>;
    @Input() archiveEnabled: boolean;
    @Input() isMessageTab: boolean;
    @Input() refresh: Observable<any>;
    @Output()
    private sizeNewChanged = new EventEmitter<number>();

    private itemsCount: number;
    private page: number = 1;
    private limit: number = 10;
    private notificationList: Array<any>;
    private unreadMessagesAmount: any;
    private sub: Subscription;
    private isLoading: boolean;
    private currentRoute: string;
    private selectedCount: number = 0;
    private items: Array<any> = [];
    private selectedIndices: boolean[];
    private selectedItems: any[] = [];
    private actionEnabled: boolean;
    private isAnyUnread: boolean;
    private newMessageAmount: number;

    constructor(
        private inboxService: InboxService,
        private route: ActivatedRoute,
        private sessionService: SessionService,
        private router: Router,
        private socketService: SocketService
    ) {
        super();
        router.events
            .filter(event => event instanceof NavigationStart)
            .bindToLifecycle(this)
            .subscribe((event: NavigationStart) => {
                if ((event.url.indexOf('/inbox?tab=archive') !== -1) || (event.url.indexOf('/inbox?tab=inbox') !== -1)
                    || (event.url.indexOf('/inbox?tab=archivedMessages') !== -1) || (event.url.indexOf('/inbox?tab=messages') !== -1)) {
                    this.fetchItems();
                }
            });
    }

    ngOnInit() {
        this.currentRoute = this.router.routerState.snapshot.url.split(';')[0];
        if (this.route.snapshot.params['restore']) {
            let params = this.sessionService.get(this.currentRoute);
            if (params) {
                if (params.page)
                    this.page = params.page;
                if (params.limit)
                    this.limit = params.limit;
            }
        }
        this.fetchItems();

        if (this.refresh) {
            this.sub = this.refresh.subscribe(_ => {
                console.log('inbox update')
                this.fetchItems()
            });
        }
    };
    ngOnDestroy() {
        this.sub.unsubscribe();
        let data = {
            page: this.page,
            limit: this.limit
        };

        this.sessionService.set(this.currentRoute, data);
    };
    private fetchItems() {
        let params = {
            page: this.page,
            limit: this.limit
        };
        this.actionEnabled = this.selectedItems.length !== 0;
        this.isLoading = true;
        this.sub = this.inboxService.list(params, this.url)
            .take(1)
            .subscribe(
                body => {
                    let items = body.data;
                    this.itemsCount = body.flags.size;
                    this.newMessageAmount = body.flags.sizeNew || body.flags.sizeNotRead;
                    this.isAnyUnread = this.checkIfAnyUnreadOnPage(items);
                    this.items = body.data;
                    this.sizeNewChanged.emit(this.newMessageAmount);
                    this.selectedIndices = [];
                    this.selectedIndices.length = this.items.length;
                    this.selectedCount = 0;
                    for (let i = 0; i < this.items.length; i++) {
                        let index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
                        if (index > -1) {
                            this.selectedCount++;
                            this.selectedIndices[i] = true;
                            this.selectedItems[index] = items[i];
                        }
                    }
                    this.notificationList = body.data;
                    this.isLoading = false;
                    if (this.itemsCount > 0) {
                        this.unreadMessagesAmount = body.flags.sizeNew;
                    }
                }
            );
    };
    private checkIfAnyUnreadOnPage(items: any) {
        return Array.isArray(items) && items.some(el => el.isNew || el.isNewMessage)
    }
    private onPageChanged(event: any) {
        this.page = event.page;
        this.fetchItems();
    };
    private onFormatText(text: string, index: number) {
        if (text && text.length > index) {
            return text.substring(0, index) + '...'
        } else {
            return text
        }
    };
    private onLimitChange(event: any) {
        this.limit = event.target.value;
        this.page = 1;
        this.fetchItems();
    };
    private onAllChecked(checked: boolean) {
        this.items.forEach((item, index) => {
            this.checkItem(checked, index);
        });
        this.refreshBulkActionsBar();
    };
    private refreshBulkActionsBar() {
        this.actionEnabled = this.selectedItems.length !== 0;
    };
    private checkItem(checked: boolean, index: number) {
        this.selectedIndices[index] = checked;
        let pos = this.selectedItems.findIndex(i => this.isSameItem(i, this.items[index]));

        if (checked) {
            if (pos === -1) {
                this.selectedCount++;
                this.selectedItems.push(this.items[index]);
            }
        } else {
            if (pos > -1) {
                this.selectedCount--;
                this.selectedItems.splice(pos, 1);
            }
        }
    };
    private isSameItem(i1: any, i2: any): boolean {
        return i1['id'] === i2['id']
    };
    private onItemChecked(checked: boolean, index: number) {
        this.checkItem(checked, index);
        this.refreshBulkActionsBar();
    };
    private onChangeMessageStatusBulkAction(status: boolean) {
        if (this.isMessageTab) {
            let details = { markAsRead: !status, idsToUpdate: this.extractId(this.selectedItems) };
            this.inboxService.changeConversationStatus(details)
                .subscribe(
                    data => {
                        this.fetchItems()
                    }
                )
        }
    };
    private onChangeArchiveLabelBulkAction(status: boolean) {
        if (this.isMessageTab) {
            let details = { archive: status, idsToUpdate: this.extractId(this.selectedItems) };
            this.inboxService.archiveConversation(details)
                .subscribe(
                    data => {
                        this.fetchItems()
                    }
                )
        }
    };
    private onTabClick(e) {
        let tabId = e.srcElement.attributes['href'].value;
        this.router.navigate(
            ['/inbox'],
            { queryParams: { tab: tabId.substr(1) } }
        );
    };
    private extractId(selectedItems: Array<any>) {
        let result = [];
        selectedItems.forEach(el => {
            result.push(el.id)
        });
        return result;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/inbox/common/components/inbox-tab/inbox-tab.component.ts